import { Call } from 'starknet';
import { getConfigManager } from '../../config/getConfigManager';
import { Decimal } from '../../datastructures';
import { MultiCallContract } from '../../services';
import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { createAsyncAtom } from '../../lib/state';
import rpcProviderAtom from '../rpcProviderAtom';

const RESPONSE_CHUNK_SIZE = 2;

const poolsSwapFeeAtom = createAsyncAtom(async get => {
  const provider = await get(rpcProviderAtom);

  const pools = getConfigManager().getConfig().pools;

  const poolsSwapFeeMap: { [key: string]: Decimal } = {};

  const calldata: Call[] = Object.entries(pools).map(([, poolConfig]) => ({
    contractAddress: poolConfig.pair.address,
    entrypoint: 'swap_fee',
    calldata: [],
  }));

  const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

  const result = await multiCallContract.aggregate(calldata);
  if (!result) {
    return {};
  }

  for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
    const [, poolsConfig] = Object.entries(pools)[i / RESPONSE_CHUNK_SIZE];

    // Index 1 is swapFee
    const feeResult = result[i + 1];

    const precision = feeResult < 10000n ? 4 : 18;

    const swapFee = new Decimal(result[i + 1], precision);

    poolsSwapFeeMap[poolsConfig.pair.id] = swapFee;
  }

  return poolsSwapFeeMap;
});
export default poolsSwapFeeAtom;
